export default "__VITE_ASSET__72dffc8b__"